module.exports = __webpack_public_path__ + "media/images/icons/twotone/reconciliation-9878253b3a6c0edc925138ad7f7ccc32.svg";